import React from 'react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Badge } from '../../components/ui/badge';
import { Phone, MessageSquare, ShieldCheck, Loader2, CheckCircle, RefreshCw, Lock, ArrowRight } from 'lucide-react';
import { HighTechCard } from './shared';
import { EnvoyerLienSignatureMembre } from '../../components/EnvoyerLienSignatureMembre';

export default function StepSignatureSMS({ ctx }) {
  const {
    ftpeSmsLoading, rcdsSmsLoading, ftpeSigned, ftpeOtpEnvoye, ftpeTelephone, setFtpeTelephone,
    ftpeCodeOtp, setFtpeCodeOtp, isFtpeMember,
    handleFtpeSendOtp, handleFtpeValidateSignature, renvoyerCodeFTPE,
    signatureValidee, telephoneSignature, setTelephoneSignature,
    codeSMSEnvoye, codeSMS, setCodeSMS, demoCode,
    envoyerCodeSMS, validerCodeSMS, renvoyerCodeSMS, souscriptionId, ftpeAdhesionId
  } = ctx;

  const skipFtpe = isFtpeMember === true;
  const rcdsEnabled = skipFtpe || ftpeSigned;

  return (
    <HighTechCard gradient="purple">
      <div className="p-6 sm:p-8 space-y-8">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-10 h-10 bg-purple-600 rounded-full flex items-center justify-center text-white font-bold">5</div>
          <h2 className="text-xl font-bold text-gray-800 flex items-center gap-2"><ShieldCheck className="h-5 w-5 text-purple-600" /> Signature electronique par SMS</h2>
        </div>

        {/* === SECTION 1 : FTPE (si pas deja membre) === */}
        {!skipFtpe && (
          <div className={`border-2 rounded-xl p-6 transition-all ${ftpeSigned ? 'border-green-300 bg-green-50/50' : 'border-blue-300 bg-blue-50/30'}`}>
            <div className="flex items-center gap-3 mb-4">
              <div className={`w-8 h-8 rounded-full flex items-center justify-center text-white text-sm font-bold ${ftpeSigned ? 'bg-green-500' : 'bg-blue-600'}`}>1</div>
              <h3 className="text-lg font-bold text-gray-800">Signature FTPE</h3>
              {ftpeSigned && <Badge className="bg-green-700 text-white text-xs font-semibold"><CheckCircle className="h-3 w-3 mr-1" />Signee</Badge>}
            </div>

            {ftpeSigned ? (
              <div className="flex items-center gap-3 p-4 bg-green-100 rounded-lg">
                <CheckCircle className="h-6 w-6 text-green-600" />
                <p className="text-green-800 font-medium">Signature FTPE validee. Vous pouvez maintenant signer la souscription RCDS ci-dessous.</p>
              </div>
            ) : !ftpeOtpEnvoye ? (
              <div className="space-y-3">
                <p className="text-sm text-gray-600">Entrez votre numero de telephone pour recevoir le code de validation FTPE</p>
                <div className="flex gap-3">
                  <div className="relative flex-1">
                    <Phone className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-blue-400" />
                    <Input
                      value={ftpeTelephone}
                      onChange={(e) => setFtpeTelephone(e.target.value)}
                      placeholder="06 12 34 56 78"
                      className="pl-10 h-12 text-lg"
                      data-testid="ftpe-phone-input"
                    />
                  </div>
                  <Button onClick={handleFtpeSendOtp} disabled={ftpeSmsLoading} className="h-12 px-6 bg-blue-600 hover:bg-blue-700" data-testid="ftpe-send-otp">
                    {ftpeSmsLoading ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : <MessageSquare className="h-4 w-4 mr-2" />}
                    Envoyer
                  </Button>
                </div>
              </div>
            ) : (
              <div className="space-y-3">
                <p className="text-sm text-gray-600">Entrez le code de validation FTPE recu par SMS</p>
                <div className="flex gap-3">
                  <Input
                    value={ftpeCodeOtp}
                    onChange={(e) => setFtpeCodeOtp(e.target.value)}
                    placeholder="Code FTPE"
                    className="h-12 text-lg text-center tracking-widest font-mono"
                    maxLength={6}
                    data-testid="ftpe-otp-input"
                  />
                  <Button onClick={handleFtpeValidateSignature} disabled={ftpeSmsLoading || ftpeCodeOtp.length < 4} className="h-12 px-6 bg-blue-600 hover:bg-blue-700" data-testid="ftpe-validate-otp">
                    {ftpeSmsLoading ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : <ShieldCheck className="h-4 w-4 mr-2" />}
                    Valider FTPE
                  </Button>
                </div>
                <Button variant="ghost" size="sm" onClick={renvoyerCodeFTPE} disabled={ftpeSmsLoading} className="text-xs text-blue-600" data-testid="ftpe-resend-otp">
                  <RefreshCw className="h-3 w-3 mr-1" /> Renvoyer le code FTPE
                </Button>
              </div>
            )}
          </div>
        )}

        {/* === SECTION 2 : RCDS BATICO === */}
        <div className={`border-2 rounded-xl p-6 transition-all ${!rcdsEnabled ? 'border-gray-200 bg-gray-50/50' : signatureValidee ? 'border-green-300 bg-green-50/50' : 'border-purple-300 bg-purple-50/30'}`}>
          <div className="flex items-center gap-3 mb-4">
            <div className={`w-8 h-8 rounded-full flex items-center justify-center text-white text-sm font-bold ${!rcdsEnabled ? 'bg-gray-400' : signatureValidee ? 'bg-green-500' : 'bg-purple-600'}`}>
              {skipFtpe ? '1' : '2'}
            </div>
            <h3 className={`text-lg font-bold ${!rcdsEnabled ? 'text-gray-400' : 'text-gray-800'}`}>Signature RCDS BATICO</h3>
            {signatureValidee && <Badge className="bg-green-700 text-white text-xs font-semibold"><CheckCircle className="h-3 w-3 mr-1" />Signee</Badge>}
            {!rcdsEnabled && (
              <Badge className="bg-amber-600 text-white text-xs font-semibold"><Lock className="h-3 w-3 mr-1" />Signez d'abord FTPE</Badge>
            )}
          </div>

          {!rcdsEnabled ? (
            <div className="flex items-center gap-3 p-4 bg-amber-50 rounded-lg border border-amber-200">
              <Lock className="h-5 w-5 text-amber-500 shrink-0" />
              <div>
                <p className="text-amber-800 font-medium text-sm">Section verrouillee</p>
                <p className="text-amber-600 text-xs">Completez d'abord la signature FTPE ci-dessus pour debloquer cette section.</p>
              </div>
              <ArrowRight className="h-5 w-5 text-amber-400 animate-pulse" />
            </div>
          ) : signatureValidee ? (
            <div className="flex items-center gap-3 p-4 bg-green-100 rounded-lg">
              <CheckCircle className="h-6 w-6 text-green-600" />
              <p className="text-green-800 font-medium">Signature RCDS validee ! Passage au paiement...</p>
            </div>
          ) : (
            <div className="space-y-4">
              {!codeSMSEnvoye ? (
                <div className="space-y-3">
                  <p className="text-sm text-gray-600">Entrez votre numero de telephone pour recevoir le code de validation RCDS</p>
                  <div className="flex gap-3">
                    <div className="relative flex-1">
                      <Phone className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-purple-400" />
                      <Input
                        value={telephoneSignature}
                        onChange={(e) => setTelephoneSignature(e.target.value)}
                        placeholder="06 12 34 56 78"
                        className="pl-10 h-12 text-lg"
                        data-testid="rcds-phone-input"
                      />
                    </div>
                    <Button onClick={envoyerCodeSMS} disabled={rcdsSmsLoading} className="h-12 px-6 bg-purple-600 hover:bg-purple-700" data-testid="rcds-send-sms">
                      {rcdsSmsLoading ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : <MessageSquare className="h-4 w-4 mr-2" />}
                      Envoyer
                    </Button>
                  </div>
                </div>
              ) : (
                <div className="space-y-3">
                  <div className="flex items-center gap-2">
                    <CheckCircle className="h-4 w-4 text-green-500" />
                    <span className="text-sm text-green-700 font-medium">Code envoye au {telephoneSignature}</span>
                  </div>
                  {demoCode && (
                    <div className="bg-amber-50 border border-amber-200 rounded-lg p-3">
                      <p className="text-amber-800 text-sm font-mono text-center">Mode demo - Code: <strong className="text-lg">{demoCode}</strong></p>
                    </div>
                  )}
                  <div className="flex gap-3">
                    <Input
                      value={codeSMS}
                      onChange={(e) => setCodeSMS(e.target.value)}
                      placeholder="Entrez le code recu"
                      className="h-14 text-xl text-center tracking-[0.5em] font-mono"
                      maxLength={6}
                      data-testid="rcds-otp-input"
                    />
                    <Button
                      onClick={validerCodeSMS}
                      disabled={rcdsSmsLoading || codeSMS.length < 4}
                      className="h-14 px-8 bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-lg"
                      data-testid="rcds-validate-sms"
                    >
                      {rcdsSmsLoading ? <Loader2 className="h-5 w-5 animate-spin" /> : <ShieldCheck className="h-5 w-5 mr-2" />}
                      Valider
                    </Button>
                  </div>
                  <Button variant="ghost" size="sm" onClick={renvoyerCodeSMS} disabled={rcdsSmsLoading} className="text-xs text-purple-600" data-testid="rcds-resend-sms">
                    <RefreshCw className="h-3 w-3 mr-1" /> Renvoyer le code
                  </Button>
                </div>
              )}
            </div>
          )}
        </div>

        {!signatureValidee && (
          <EnvoyerLienSignatureMembre souscriptionId={souscriptionId} telephone={telephoneSignature || ftpeTelephone} ftpeAdhesionId={ftpeAdhesionId} />
        )}

      </div>
    </HighTechCard>
  );
}
